import { Injectable } from '@angular/core';
import { LevelOfMembershipDataService } from '../api/levelofmembership-data.service';

@Injectable({
    providedIn: 'root'
})

export class LevelOfMembershipService {
    constructor(private levelofmembershipDataService: LevelOfMembershipDataService) { }

    //Get All Level of Membership
    public getAllLevelOfMembership() {
        return this.levelofmembershipDataService.getAllLevelOfMembership();
    }

    //Get Level of Membership By Id
    public getLevelDataById(id) {
        return this.levelofmembershipDataService.getLevelDataById(id);
    }
}